(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rf-addons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rf-accessories')) {
  customElements.define('rf-accessories', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      this.form = this.closest('form');
      if (!this.form || !this.querySelector('[data-rf-addon]')) return;
      try { this.variants = JSON.parse(this.dataset.variants); } catch { return; }
      const update = () => {
        const id = this.form.querySelector('[name="id"]')?.value;
        const variant = this.variants.find(item => String(item.id) === id);
        const quantity = Math.max(1, Number(this.form.querySelector('[name="quantity"]')?.value || 1));
        const extra = [...this.querySelectorAll('[data-rf-addon]:checked')].reduce((sum,input) => sum + Number(input.dataset.price),0);
        const total = (variant?.price || 0) * quantity + extra;
        this.querySelector('[data-rf-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency:this.dataset.currency}).format(total / 100);
      };
      const options = {signal:this.controller.signal};
      this.form.addEventListener('change',update,options);this.form.addEventListener('input',update,options);
      this.closest('.shopify-section')?.addEventListener('variant:update', () => queueMicrotask(update),options);
      update(); this.hidden = false;
    }
    disconnectedCallback(){ this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rf-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const running = new Set();
  let observer;
  const enabled = () => document.body.dataset.rfMotion === 'true' && !preference.matches && !window.Shopify?.designMode;
  const reveal = (element, delay = 0) => {
    if (!enabled() || !element.animate) return;
    const animation = element.animate([{ opacity: .65, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 620, delay, easing: 'cubic-bezier(.2,.65,.3,1)' });
    running.add(animation);
    animation.onfinish = animation.oncancel = () => running.delete(animation);
  };
  const initialize = (root = document) => {
    if (!enabled() || !('IntersectionObserver' in window)) return;
    if (!observer) observer = new IntersectionObserver((entries) => {
      let index = 0;
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        reveal(entry.target, Math.min(index++ * 55, 165));
      });
    }, { threshold: .08 });
    root.querySelectorAll('.rf-path,.rf-section-head,.rf-finder-card,.rf-editorial__image,.rf-editorial__copy,.rf-faq__intro,.rf-faq__items,.rf-box-benefits__card').forEach((element) => {
      if (seen.has(element)) return;
      seen.add(element);
      if (element.getBoundingClientRect().top >= window.innerHeight) observer.observe(element);
    });
  };
  const start = () => {
    initialize();
    if (enabled()) document.querySelectorAll('.rf-hero__copy,.rf-hero__visual').forEach((element,index) => reveal(element,index*90));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  preference.addEventListener('change', () => {
    if (preference.matches) { observer?.disconnect(); running.forEach((animation) => animation.cancel()); }
    else initialize();
  });
  window.addEventListener('pagehide', () => running.forEach((animation) => animation.cancel()));
})();
  } catch(e) { console.error(e); }
})();

})();
